import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import HomeRouter from './routes/homeRoutes';
import AuthRouter from './routes/authRoutes';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getLoggedInUser } from './redux/features/auth/actions';
import { Box, LinearProgress } from '@mui/material';
import DriverRouter from './routes/driverRoutes';
import { USER_ROLES } from './config/enum';

export default function App() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth.status.user);
  const { user, token } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getLoggedInUser());
    // eslint-disable-next-line
  }, [token]);

  const renderRoutes = (role) => {
    switch (role) {
      case USER_ROLES.ADMIN:
        return <HomeRouter />;
      case USER_ROLES.EMPLOYEE:
        return <DriverRouter />;
      default:
        return <AuthRouter />;
    }
  };

  return (
    <>
      {loading ? (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      ) : (
        renderRoutes(user?.role)
      )}
      <ToastContainer />
    </>
  );
}
